import React from "react";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import useStyles from "./styles";

export interface Props {
  onCancel: () => void;
  onDelete: () => void;
  open: boolean;
  children: React.ReactNode;
}

const DeleteConfirmationDialog = (props: Props) => {
  const { children, onCancel, onDelete, open } = props;
  const classes = useStyles();

  const handleCancel = () => {
    onCancel();
  };

  const handleDelete = () => {
    onDelete();
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      className={classes.confirmationDialog}
    >
      <DialogTitle>
        <Typography className={classes.dialogTitleTypography}>
          Delete Comment?
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.dialogContentText}>
          You are about to permanently delete your comment from:
        </Typography>
        <Typography
          className={clsx(
            classes.dialogContentText,
            classes.bold,
            classes.center,
            classes.black,
            classes.mt18
          )}
        >
          {children}
        </Typography>
      </DialogContent>
      <DialogActions>
        <div className={classes.decisions}>
          <Button
            className={clsx(classes.button, classes.cancel)}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            className={clsx(classes.button, classes.discard)}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
